<template>
  <modal name="change-status-modal"
         @closed="$emit('updateComparisonData')"
         @before-open="beforeOpen"
         style="z-index: 1001;">
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Փոխել կարգավիճակը</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('change-status-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4" style="overflow-x: auto; height: 85%">
      <div class="form-group">
        <select v-model="status" class="form-control" id="exampleFormControlSelect1">
          <option value="sended">Պատվիրված</option>
          <option value="failed">Առաջացել է խնդիր</option>
          <option value="canceled">Չկատարված</option>
          <option value="completed">Մատակարարված</option>
        </select>
      </div>
    </div>
    <div id="modal-footer" class="bg-white w-100 p-3 text-center">
      <button @click="save" type="button" class="btn btn-primary waves-effect waves-light float-center mr-3" data-toggle="modal" data-animation="bounce">
          Պահպանել
      </button>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'SuggestionModal',
  data () {
    return {
      order: {},
      status: '',
    }
  },
  computed: {
    me() {
      return this.$store.getters['user/me']
    },
  },
  methods: {
    consoleLog(data){
      console.log(data)
    },
    async save(){
      await this.$client.put(`contract-orders/${this.order.id}`, {status: this.status}).then(({data}) => {
        if(data) {
          this.resetComponent()
          this.$modal.hide('change-status-modal')
        }
      }).catch(e => {
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Ինչ որ բան այն չէ',
          text: 'Կրկին փորձեք!'
        })
      })
    },
    beforeOpen({params}) {
      this.resetComponent = params.resetComponent
      this.order = params.order
      this.status = this.order.status
    },
  }
}
</script>
<style scoped>
  /deep/ .vm--modal {
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 20% !important;
    height: 50% !important;
    margin: auto;
    position: absolute;
    padding-bottom: 70px;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
  .status-select{
  }
</style>

